import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

// Carousel only for ratings
const Carousel = ({ ratings }) => {
  const [current, setCurrent] = useState(0);
  const slides = ratings.map((rating, idx) => ({ type: 'rating', ...rating, key: `rating-${idx}` }));
  if (!slides || slides.length === 0) return null;

  const prevSlide = () => setCurrent((current - 1 + slides.length) % slides.length);
  const nextSlide = () => setCurrent((current + 1) % slides.length);

  return (
    <div style={carouselStyles.container}>
      <button style={carouselStyles.arrow} onClick={prevSlide}>&lt;</button>
      <div style={carouselStyles.ratingCard}>
        <div style={{ fontSize: '1.8rem', color: '#FFD700', marginBottom: '10px' }}>
          {'★'.repeat(slides[current].rating)}
          {'☆'.repeat(5 - slides[current].rating)}
        </div>
        <div style={{ fontSize: '1.1rem', color: '#333', fontStyle: 'italic', marginBottom: '8px' }}>
          "{slides[current].comment}"
        </div>
        <div style={{ fontSize: '0.95rem', color: '#8d6e36' }}>
          - Customer
        </div>
      </div>
      <button style={carouselStyles.arrow} onClick={nextSlide}>&gt;</button>
      <div style={carouselStyles.dots}>
        {slides.map((_, idx) => (
          <span
            key={idx}
            style={{
              ...carouselStyles.dot,
              background: idx === current ? '#8d6e36' : '#ccc'
            }}
            onClick={() => setCurrent(idx)}
          />
        ))}
      </div>
    </div>
  );
};

const carouselStyles = {
  container: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    margin: '24px 0',
    position: 'relative',
    width: '100%',
    maxWidth: '600px',
    marginLeft: 'auto',
    marginRight: 'auto',
  },
  ratingCard: {
    width: '500px',
    height: '220px',
    background: '#f5f6fa',
    borderRadius: '12px',
    boxShadow: '0 2px 8px rgba(141,110,54,0.15)',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '24px',
    textAlign: 'center',
  },
  arrow: {
    background: '#8d6e36',
    color: '#fff',
    border: 'none',
    borderRadius: '50%',
    width: '36px',
    height: '36px',
    fontSize: '1.5rem',
    cursor: 'pointer',
    margin: '0 12px',
    zIndex: 1,
  },
  dots: {
    position: 'absolute',
    bottom: '10px',
    left: '50%',
    transform: 'translateX(-50%)',
    display: 'flex',
    gap: '8px',
  },
  dot: {
    width: '12px',
    height: '12px',
    borderRadius: '50%',
    display: 'inline-block',
    cursor: 'pointer',
  },
};

const ServiceList = () => {
  const [services, setServices] = useState([]);
  const [ratings, setRatings] = useState([]);
  const navigate = useNavigate();

  // Get logged in user info
  const loggedInUser = JSON.parse(localStorage.getItem('user') || '{}');

  useEffect(() => {
  fetch(`${process.env.REACT_APP_VENDOR_DOMAIN}/api/services`)
      .then(res => res.json())
      .then(data => {
        const serviceArray = Array.isArray(data)
          ? data
          : Object.values(data);
        // Only display services where is_active is true
        const activeServices = serviceArray.filter(service => service.is_active === true || service.is_active === 1);
        setServices(activeServices);
      })
      .catch(() => setServices([]));

    // Fetch customer ratings
  fetch(`${process.env.REACT_APP_VENDOR_DOMAIN}/customer_ratings`)
      .then(res => res.json())
      .then(data => {
        // Only show ratings that are four stars or more
        const filteredRatings = (data.ratings || []).filter(r => r.rating >= 4);
        setRatings(filteredRatings);
      })
      .catch(() => setRatings([]));
  }, []);

  const handleServiceClick = (id) => {
    navigate(`/service_customer_details/${id}`);
  };

  const handleBookProvider = () => {
    const token = localStorage.getItem('token');
    if (!token) {
      window.location.href = '/signup';
    } else {
      window.location.href = '/search';
    }
  };

  return (
    <div style={styles.container}>
      <h2 style={styles.title}>Available Services</h2>
      <div style={styles.cardGrid}>
        {services.map(service => (
          <div
            key={service.id}
            style={{ ...styles.card, cursor: 'pointer' }}
            onClick={() => handleServiceClick(service.id)}
          >
            {service.image_url && (
              <img
                src={service.image_url}
                alt={service.title || service.name}
                style={{ width: '100%', height: '120px', objectFit: 'cover', borderRadius: '6px', marginBottom: '12px' }}
              />
            )}
            <h3 style={styles.cardTitle}>{service.title || service.name}</h3>
            <p style={styles.cardDesc}>{service.description || ''}</p>
          </div>
        ))}
      </div>
      {/* Add heading above the customer review carousel */}
      <h3
        style={{
          textAlign: 'center',
          color: '#ff9800',
          fontSize: '1.5rem',
          margin: '48px 0 18px 0',
          fontWeight: 'bold',
          letterSpacing: '1px',
          textShadow: '2px 2px 8px #ffe0b2, 0 0 4px #8d6e36',
          background: 'linear-gradient(90deg, #fffde4 0%, #ffe0b2 100%)',
          borderRadius: '12px',
          padding: '14px 0',
          boxShadow: '0 2px 12px rgba(255,152,0,0.10)',
          fontFamily: 'cursive, sans-serif',
        }}
      >
        <span role="img" aria-label="sparkle" style={{ marginRight: 8 }}>✨</span>
        What Customers Are Saying
        <span role="img" aria-label="sparkle" style={{ marginLeft: 8 }}>✨</span>
      </h3>
      {/* Carousel now only shows customer ratings */}
      <Carousel ratings={ratings} />
      <div style={styles.bottomText}>
        <span>
          <i className="fas fa-users" style={{ color: '#6ec6f1', marginRight: 8 }}></i>
          Meet your online STEM coaches who are <span style={{ color: '#388e3c', fontWeight: 'bold' }}>passionate</span> about what they do.
        </span>
      </div>
      <div style={styles.infoCardsContainer}>
        <div style={styles.infoCard}>
          <img
            src="https://cdn-icons-png.flaticon.com/512/622/622669.png"
            alt="Search"
            style={styles.infoImg}
          />
          <h4 style={styles.infoTitle}>Search</h4>
          <p style={styles.infoDesc}>Find an experienced STEM coach for your educational needs.</p>
        </div>
        <div style={styles.infoCard}>
          <img
            src="https://cdn-icons-png.flaticon.com/512/3523/3523887.png"
            alt="Book & Pay"
            style={styles.infoImg}
          />
          <h4 style={styles.infoTitle}>Book & Pay</h4>
          <p style={styles.infoDesc}>Book your service and pay securely online.</p>
        </div>
        <div style={styles.infoCard}>
          <img
            src="https://cdn-icons-png.flaticon.com/512/1680/1680899.png"
            alt="Relax"
            style={styles.infoImg}
          />
          <h4 style={styles.infoTitle}>Relax</h4>
          <p style={styles.infoDesc}>Sit back and relax while your STEM Coach takes care of everything.</p>
        </div>
      </div>
      <div style={styles.peaceContainer}>
        <h3 style={styles.peaceTitle}>Find peace of mind with every booking.</h3>
        <ul style={styles.peaceList}>
         
          <li>
            <span style={styles.peaceHighlight}>24/7 support</span> from the Jaca team–here to help if you ever need someone to talk to.
          </li>
        </ul>
        <div style={{ textAlign: 'center', marginTop: '28px' }}>
          {loggedInUser.user_type === 1 && (
            <button
              style={styles.bookBtn}
              onClick={handleBookProvider}
            >
              <i className="fas fa-calendar-check" style={{ marginRight: 8 }}></i>
              Book a Coach Now
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

const styles = {
  container: {
    maxWidth: '900px',
    margin: '40px auto',
    padding: '24px',
    background: '#fff',
    borderRadius: '8px',
    boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
  },
  title: {
    textAlign: 'center',
    marginBottom: '32px',
    color: '#8d6e36', // brown
    fontSize: '2rem',
    fontWeight: 'bold',
    letterSpacing: '1px',
  },
  cardGrid: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '24px',
    justifyContent: 'center',
  },
  card: {
    background: '#f5f6fa',
    borderRadius: '8px',
    boxShadow: '0 1px 4px rgba(0,0,0,0.07)',
    padding: '24px',
    width: '220px',
    textAlign: 'center',
    transition: 'box-shadow 0.2s',
  },
  cardTitle: {
    margin: '0 0 12px 0',
    color: '#8d6e36', // brown
    fontSize: '1.2rem',
    fontWeight: 'bold',
  },
  cardDesc: {
    color: '#555',
    fontSize: '1rem',
    margin: 0,
  },
  bottomText: {
    marginTop: '40px',
    textAlign: 'center',
    color: '#2e7d32',
    fontSize: '1.15rem',
    fontWeight: 'bold',
    letterSpacing: '0.5px',
    background: 'rgba(110,198,241,0.08)',
    padding: '12px 0',
    borderRadius: '8px',
    boxShadow: '0 1px 4px rgba(110,198,241,0.08)',
  },
  infoCardsContainer: {
    display: 'flex',
    justifyContent: 'center',
    gap: '32px',
    marginTop: '32px',
    marginBottom: '16px',
  },
  infoCard: {
    background: '#f5f6fa',
    borderRadius: '10px',
    boxShadow: '0 1px 6px rgba(0,0,0,0.10)',
    padding: '24px 18px',
    width: '200px',
    textAlign: 'center',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    transition: 'box-shadow 0.2s, transform 0.2s',
    cursor: 'pointer',
  },
  infoImg: {
    width: '48px',
    height: '48px',
    marginBottom: '12px',
    borderRadius: '8px',
    boxShadow: '0 1px 4px rgba(110,198,241,0.12)',
  },
  infoTitle: {
    fontSize: '1.1rem',
    color: '#8d6e36', // brown
    marginBottom: '8px',
    fontWeight: 'bold',
    letterSpacing: '0.5px',
  },
  infoDesc: {
    fontSize: '0.98rem',
    color: '#555',
    margin: 0,
  },
  peaceContainer: {
    marginTop: '40px',
    background: '#f5f6fa',
    borderRadius: '10px',
    boxShadow: '0 1px 6px rgba(0,0,0,0.08)',
    padding: '28px 24px',
    maxWidth: '700px',
    marginLeft: 'auto',
    marginRight: 'auto',
  },
  peaceTitle: {
    color: '#8d6e36', // brown
    fontSize: '1.3rem',
    fontWeight: 'bold',
    marginBottom: '18px',
    textAlign: 'center',
    letterSpacing: '0.5px',
  },
  peaceList: {
    listStyle: 'disc inside',
    color: '#2e7d32',
    fontSize: '1.08rem',
    paddingLeft: '0',
    margin: 0,
    lineHeight: '1.7',
  },
  peaceHighlight: {
    color: '#8d6e36', // brown
    fontWeight: 'bold',
  },
  peaceImg: {
    width: '100%',
    maxWidth: '320px',
    borderRadius: '8px',
    margin: '12px 0',
    display: 'block',
    boxShadow: '0 1px 4px rgba(110,198,241,0.12)',
  },
  peaceMsg: {
    color: '#388e3c',
    fontWeight: 'bold',
    fontSize: '1.05rem',
    marginTop: '8px',
    display: 'flex',
    alignItems: 'center',
  },
  peaceLink: {
    color: '#8d6e36', // brown
    textDecoration: 'underline',
    fontWeight: 'bold',
  },
  bookBtn: {
    background: 'linear-gradient(90deg, #8d6e36 0%, #388e3c 100%)', // brown to green
    color: '#fff',
    fontWeight: 'bold',
    fontSize: '1.1rem',
    border: 'none',
    borderRadius: '8px',
    padding: '14px 32px',
    cursor: 'pointer',
    boxShadow: '0 2px 8px rgba(141,110,54,0.15)',
    transition: 'background 0.2s, transform 0.2s',
    marginTop: '12px',
  },
};

export default ServiceList;

